import styled from 'styled-components';

import {
    Upsell,
} from '@zillow/constellation';

export const StyledUpsell = styled(Upsell)`
    box-shadow: none;

    [class^="MediaObject__Media"] {
        width: ${props => props.iconWidthPX};
    }

    [class^="TextButton"] {
        text-decoration: none;
    }
`;
